
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const missionSlice = createSlice({
    name: 'missions',
    loading: false,
    initialState: {
        missionlist: [],
        missionCount: 0
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.missionlist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.missionlist = action.payload.data?action.payload.data:[];
            state.missionCount = action.payload.count || 0
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = missionSlice.actions;
//console.log(body);

export const fetchMissions = (body)=> apiCallBegan({
    url: '/mission-vision/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});













